/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Skeleton from "@mui/material/Skeleton";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Auth context
import { useAuth } from "context/auth/authContext";

// Utilities
import { stringAvatar } from "utils/avatar";

function Header(): JSX.Element {
  const { user, isLoading } = useAuth();
  const [avatarProps, setAvatarProps] = useState<any>(null);
  
  useEffect(() => {
    if (user && user.firstName && user.lastName) {
      setAvatarProps(stringAvatar(`${user.firstName} ${user.lastName}`));
    }
  }, [user]);

  return (
    <Card id="profile">
      <MDBox p={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            {isLoading ? (
              <Skeleton variant="circular" width={80} height={80} />
            ) : (
              <Avatar 
                {...avatarProps} 
                sx={{ 
                  width: 80, 
                  height: 80,
                  fontSize: '2rem',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' 
                }} 
              />
            )}
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              {isLoading ? (
                <>
                  <Skeleton variant="text" width={150} height={30} />
                  <Skeleton variant="text" width={100} height={20} />
                </>
              ) : (
                <>
                  <MDTypography variant="h5" fontWeight="medium">
                    {user ? `${user.firstName} ${user.lastName}` : 'User'}
                  </MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="medium">
                    {user?.role || 'Account Settings'}
                  </MDTypography>
                </>
              )}
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default Header;
